import { Outlet, useParams } from 'react-router-dom'

import { JobCatalogRolePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import useCanEditRole from 'modules/job_catalog/hooks/useCanEditRole'
import { useRole } from 'modules/job_catalog/hooks/useRole'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

function Component() {
  const { id } = useParams<{ id: string }>()
  const [role, isFetching] = useRole(String(id))
  const [canEditRole, isLoading] = useCanEditRole(role)

  const { company } = useCurrentSession()
  const { data, loading: loadingCompetenciesAvailability } = useQuery(JobCatalogRolePageDocument, {
    variables: { companyId: company.id },
  })

  if (!role) {
    return null
  }

  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <Outlet
        context={{
          role,
          canEditRole,
          isLoading: isFetching || isLoading || loadingCompetenciesAvailability,
          competenciesAvailable: data?.companies.featureAvailabilities[0]?.available ?? false,
          canManageCompetencies: data?.competencies._policies.competenciesManage.can ?? false,
        }}
      />
    </ResponsivePage.Body>
  )
}

export default Component
